export class CreateIntegrationConfigurationDto {

    integrationName: string;

    integrationConfig: Record<string, string>;

}
